import { usePremiumBenefitsList } from 'app/components/subscriptions/dialogs/ManageYourPlanDialog';
import { PremiumPlanInfoTooltip } from 'app/components/subscriptions/dialogs/ManageYourPlanDialog/components';
import { PlanPricing } from 'app/components/subscriptions/dialogs/ManageYourPlanDialog/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SubscriptionPlanCard } from '../SubscriptionPlanCard';
import './PremiumInfoPlanCard.less';

interface Props {
  isCurrent?: boolean;
  isAnnuallyBilling: boolean;
  planPricing?: PlanPricing;
  isLoading: boolean;
  isUpgrading: boolean;
  onUpgrade?: () => void;
}

export default function PremiumInfoPlanCard({
  isCurrent,
  isAnnuallyBilling,
  planPricing,
  isLoading,
  isUpgrading,
  onUpgrade,
}: Props) {
  const { t } = useTranslation();

  const benefits = usePremiumBenefitsList();

  return (
    <SubscriptionPlanCard
      isCurrent={isCurrent}
      title={
        <>
          {t('subscriptions.manage_your_plan.premium_telematics_plan.title')}

          <PremiumPlanInfoTooltip />
        </>
      }
      subtitle={
        <span className="premium-info-plan-card__subtitle">
          <span className="premium-info-plan-card__price">
            $
            {planPricing
              ? isAnnuallyBilling
                ? planPricing.annually.amount
                : planPricing.monthly.amount
              : 0}
          </span>
          {t(
            `subscriptions.manage_your_plan.premium_telematics_plan.${
              isAnnuallyBilling ? 'price_per_year' : 'price_per_month'
            }`,
          )}
        </span>
      }
      isSubtitleLoading={isLoading}
      buttonLabel={t('subscriptions.manage_your_plan.upgrade')}
      isButtonLoading={isLoading || isUpgrading}
      featuresTitle={{
        i18nKey:
          'subscriptions.manage_your_plan.premium_telematics_plan.access_to_all',
      }}
      features={benefits}
      onUpgrade={onUpgrade}
    />
  );
}
